'use client';
import { FC, useEffect, useState } from 'react';
import AppsShelveSearchResults from '../shelve/apps-shelve/apps-shelve-search-results';
import { useClassName } from '../../hooks/use-class-name';
import { SearchResultsPlaceHolder } from './placeholder';
import { useTranslation } from '../../hooks/use-translation';
import { useAnalytics } from '../../hooks/use-analytics';
import Utils from '../../utils/utils';
import { OwAppTile } from '../../interfaces/domain/ow-app-tile.modal';
import useBus from '../../hooks/use-bus';
import { AppBusEventType } from '../../interfaces/bus-events';

interface Props {}

// -----------------------------------------------------------------------------
export const SearchResults: FC<Props> = (): JSX.Element => {
  const [showResults, setShowResults] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchResults, setSearchResults] = useState<OwAppTile[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { t } = useTranslation();
  const analytics = useAnalytics();

  useBus(AppBusEventType.App.SearchHeaderResult, (event) => {
    const { data } = event;
    setSearchResults(data.searchResults);
    setSearchTerm(data.searchTerm);
    setIsLoading(false);
    setShowResults(data?.searchResults?.length > 0);
  });

  // ---------------------------------------------------------------------------
  // track() waits for the login check and stamps postLogin itself.
  useEffect(() => {
    const query = new URLSearchParams(window.location.search).get('q');
    if (!query) {
      setIsLoading(false);
    }

    analytics.track('appstore_search_page_initialized', {
      platform: Utils.isMobile() ? 'Mobile' : 'Web',
      searchTerm: query,
    });
  }, []);

  // ---------------------------------------------------------------------------
  const searchResultsClassName = useClassName(
    {
      'is-loading': isLoading,
    },
    'search-results',
  );

  return (
    <div className={searchResultsClassName}>
      {searchResults?.length > 0 && (
        <div className="sr-header">
          <h1>
            {t('searchResults.searchFor')} “<span>{searchTerm}</span>”
          </h1>
          <p className="found">
            {searchResults.length} {t('searchResults.appsFound')}
          </p>
        </div>
      )}

      {showResults && searchResults?.length > 0 && (
        <AppsShelveSearchResults searchResults={searchResults} />
      )}

      {!searchTerm && !isLoading && <SearchResultsPlaceHolder />}

      {searchResults?.length == 0 && !isLoading && searchTerm && (
        <SearchResultsPlaceHolder query={searchTerm} isNotFound={true} />
      )}
    </div>
  );
};
